import styled from 'styled-components';

export const ListItem = styled.li`
  ::marker {
    color: var(--colors-turquoise);
    font-size: 1.2rem;
  }
  & + & {
    margin-top: 0.25em;
  }
`;

export const Heading3 = styled.h3`
  ${({ theme }) => theme.typography.titleSM};
  color: var(--colors-darkBlue);
`;

export const ImageContainer = styled.div`
  padding: 8px;
  float: left;
`;
